/* ==========================================================================

   Onera — Luxury cart drawer



   Opens from header cart triggers and after AJAX add-to-cart. Refreshes via

   the onera-cart-drawer section endpoint; quantity/remove use cart core.

   ========================================================================== */

(function () {

  const SECTION_ID = 'onera-cart-drawer';

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  const OPEN_MS = reduce.matches ? 0 : 260;

  const CLOSE_MS = reduce.matches ? 0 : 320;

  const REMOVE_MS = reduce.matches ? 0 : 150;



  const core = function () {

    return window.oneraCartCore;

  };



  const fingerprintApi = function () {

    return window.oneraCartFingerprint;

  };



  const isCheckoutBlocked = function () {

    return (

      (window.oneraCheckoutLock && window.oneraCheckoutLock.isActive()) ||

      document.querySelector('.is-preparing-checkout')

    );

  };



  /* Shared scroll lock — reference counted, compensates for scrollbar width,

     preserves scroll position (no jump). Used by cart + nav drawers. */

  const scrollLock = (function () {

    let count = 0;

    let scrollY = 0;



    const lock = function () {

      if (count > 0) {

        count += 1;

        return;

      }

      scrollY = window.scrollY;

      const scrollbarWidth =

        window.innerWidth - document.documentElement.clientWidth;

      document.documentElement.classList.add('onera-no-scroll');

      document.body.style.position = 'fixed';

      document.body.style.top = '-' + scrollY + 'px';

      document.body.style.left = '0';

      document.body.style.right = '0';

      document.body.style.width = '100%';

      if (scrollbarWidth > 0) {

        document.body.style.paddingRight = scrollbarWidth + 'px';

        document.documentElement.style.setProperty(

          '--onera-scrollbar-width',

          scrollbarWidth + 'px'

        );

      }

      count = 1;

    };



    const unlock = function () {

      if (count === 0) return;

      count -= 1;

      if (count > 0) return;



      document.documentElement.classList.remove('onera-no-scroll');

      document.documentElement.style.removeProperty('--onera-scrollbar-width');

      document.body.style.position = '';

      document.body.style.top = '';

      document.body.style.left = '';

      document.body.style.right = '';

      document.body.style.width = '';

      document.body.style.paddingRight = '';

      window.scrollTo(0, scrollY);

    };



    return { lock: lock, unlock: unlock };

  })();



  window.oneraScrollLock = scrollLock.lock;

  window.oneraScrollUnlock = scrollLock.unlock;



  const formatCountLabel = function (drawer, count) {

    if (!drawer) return String(count);

    const one = drawer.getAttribute('data-label-count-one') || '__count__ item';

    const many = drawer.getAttribute('data-label-count') || '__count__ items';

    if (count === 1) return one.replace('__count__', count);

    if (count > 1) return many.replace('__count__', count);

    return '';

  };



  const initCartDrawer = function () {

    const drawer = document.querySelector('[data-onera-cart-drawer]');

    if (!drawer) return;



    const panel = drawer.querySelector('.onera-cart-drawer__panel');

    const content = drawer.querySelector('[data-onera-cart-drawer-content]');

    const countEl = drawer.querySelector('[data-onera-cart-drawer-count]');

    const closeBtn = drawer.querySelector('.onera-cart-drawer__close');

    const errorHost = drawer.querySelector('.onera-cart-drawer__foot');

    let lastFocused = null;

    let pending = false;

    let refreshing = false;

    let refreshGen = 0;

    let closeTimer = null;

    let lastItemsFingerprint = '';

    let lastSummaryFingerprint = '';



    const focusables = function () {

      if (!panel) return [];

      return Array.prototype.slice

        .call(

          panel.querySelectorAll(

            'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'

          )

        )

        .filter(function (el) {

          return el.offsetParent !== null || el === document.activeElement;

        });

    };



    const setLineControlsDisabled = function (disabled) {

      if (!content) return;

      content.querySelectorAll('[data-onera-cart-qty-down]').forEach(function (btn) {

        btn.disabled = disabled;

      });

      content.querySelectorAll('[data-onera-cart-qty-up]').forEach(function (btn) {

        btn.disabled = disabled;

      });

      content.querySelectorAll('[data-onera-cart-qty]').forEach(function (input) {

        input.disabled = disabled;

      });

      content.querySelectorAll('[data-onera-cart-remove]').forEach(function (btn) {

        btn.disabled = disabled;

      });

      content.querySelectorAll('[data-promo-upsell-add]').forEach(function (btn) {

        btn.disabled = disabled;

      });

    };



    const setRefreshing = function (active) {

      refreshing = active;

      drawer.classList.toggle('is-refreshing', active);

      setLineControlsDisabled(active || pending);

    };



    const updateCount = function (count) {

      if (!countEl) return;

      countEl.textContent = formatCountLabel(drawer, count);

      countEl.classList.toggle('is-empty', count === 0);

    };



    const applyPartialRefresh = function (html, cart, options) {

      const api = core();

      const fp = fingerprintApi();

      const source = (options && options.source) || 'cart-drawer';

      const linesFp = fp && cart ? fp.lines(cart) : '';

      const summaryFp = fp && cart ? fp.breakdown(cart) : '';



      if (

        source === 'promotions' &&

        cart &&

        linesFp === lastItemsFingerprint &&

        summaryFp === lastSummaryFingerprint

      ) {

        const preview = api.parseSection(html, '[data-onera-cart-drawer-body]');

        const nextHasUpsell = !!(preview && preview.querySelector('[data-promo-upsell]'));

        const currentHasUpsell = !!(content && content.querySelector('[data-promo-upsell]'));

        if (nextHasUpsell === currentHasUpsell) return false;

      }



      const body = api.parseSection(html, '[data-onera-cart-drawer-body]');

      if (!body || !content) return false;



      if (cart && cart.item_count === 0) {

        content.innerHTML = body.outerHTML;

        lastItemsFingerprint = '';

        lastSummaryFingerprint = '';

        return true;

      }



      const nextItems = body.querySelector('[data-onera-cart-drawer-items]');

      const nextSummary = body.querySelector('[data-onera-cart-drawer-summary]');

      const nextProgress = body.querySelector('[data-onera-cart-drawer-progress]');

      const currentBody = content.querySelector('[data-onera-cart-drawer-body]') || content;

      const currentItems = currentBody.querySelector('[data-onera-cart-drawer-items]');

      const currentSummary = currentBody.querySelector('[data-onera-cart-drawer-summary]');

      const currentProgress = currentBody.querySelector('[data-onera-cart-drawer-progress]');



      if (nextProgress && currentProgress) {

        currentProgress.innerHTML = nextProgress.innerHTML;

      }



      if (nextItems && currentItems) {

        currentItems.innerHTML = nextItems.innerHTML;

      } else {

        content.innerHTML = body.outerHTML;

      }



      if (nextSummary && currentSummary && summaryFp !== lastSummaryFingerprint) {

        currentSummary.innerHTML = nextSummary.innerHTML;

      }



      if (cart) {

        lastItemsFingerprint = linesFp;

        lastSummaryFingerprint = summaryFp;

      }



      if (window.oneraCartPromotions && window.oneraCartPromotions.syncPromoUpsellVariant) {

        window.oneraCartPromotions.syncPromoUpsellVariant(content);

      }



      return true;

    };



    const refresh = function (cart, options) {

      const api = core();

      if (!content || refreshing || !api || isCheckoutBlocked()) return Promise.resolve(null);



      const gen = ++refreshGen;

      setRefreshing(true);



      return api

        .refreshSection(SECTION_ID, 'cart-drawer')

        .then(function (html) {

          if (!html || gen !== refreshGen) return null;



          const resolvedCartPromise =

            cart && typeof cart.item_count === 'number'

              ? Promise.resolve(cart)

              : api.fetchCart();



          return resolvedCartPromise.then(function (resolvedCart) {

            if (!resolvedCart || gen !== refreshGen) return null;

            applyPartialRefresh(html, resolvedCart, options);

            return resolvedCart;

          });

        })

        .then(function (resolvedCart) {

          if (!resolvedCart || gen !== refreshGen) return;



          updateCount(resolvedCart.item_count);



          api.dispatch('onera:cart:updated', {

            cart: resolvedCart,

            source: (options && options.source) || 'cart-drawer'

          });

        })

        .catch(function () {})

        .finally(function () {

          if (gen === refreshGen) {

            setRefreshing(false);

            document.dispatchEvent(new CustomEvent('onera:cart:refresh-idle'));

          }

        });

    };



    const changeLine = function (key, quantity) {

      const api = core();

      if (pending || refreshing || !key || !api) return;

      pending = true;

      setLineControlsDisabled(true);

      api.clearError(errorHost);



      api

        .changeLine(key, quantity, 'cart-drawer')

        .then(function (cart) {

          return refresh(cart, { source: 'cart-drawer' });

        })

        .catch(function (error) {

          api.showError(errorHost, api.getErrorMessage(error, 'change'));

          refresh(null, { source: 'cart-drawer' });

        })

        .finally(function () {

          pending = false;

          if (!refreshing) setLineControlsDisabled(false);

        });

    };



    const removeLine = function (line, key) {

      if (REMOVE_MS === 0 || !line) {

        changeLine(key, 0);

        return;

      }



      line.classList.add('is-removing');

      window.setTimeout(function () {

        changeLine(key, 0);

      }, REMOVE_MS);

    };



    const finishClose = function () {

      drawer.classList.remove('is-closing');

      drawer.setAttribute('aria-hidden', 'true');

      scrollLock.unlock();

      closeTimer = null;

      const api = core();

      if (api) api.dispatch('onera:cart:close');

      if (lastFocused && typeof lastFocused.focus === 'function') {

        lastFocused.focus();

      }

    };



    const close = function (instant) {

      if (!drawer.classList.contains('is-open') && !drawer.classList.contains('is-closing')) {

        return;

      }

      if (closeTimer) {

        clearTimeout(closeTimer);

        closeTimer = null;

      }



      drawer.classList.remove('is-open');



      if (instant || CLOSE_MS === 0) {

        drawer.classList.remove('is-closing');

        drawer.setAttribute('aria-hidden', 'true');

        scrollLock.unlock();

        const api = core();

        if (api) api.dispatch('onera:cart:close');

        return;

      }



      drawer.classList.add('is-closing');

      closeTimer = window.setTimeout(finishClose, CLOSE_MS);

    };



    const open = function () {

      if (drawer.classList.contains('is-open') || drawer.classList.contains('is-opening')) return;



      if (typeof window.oneraCloseNavDrawer === 'function') {

        window.oneraCloseNavDrawer(true);

      }

      if (typeof window.oneraCloseSearch === 'function') {

        window.oneraCloseSearch(true);

      }

      if (closeTimer) {

        clearTimeout(closeTimer);

        closeTimer = null;

        drawer.classList.remove('is-closing');

      }



      lastFocused = document.activeElement;

      drawer.setAttribute('aria-hidden', 'false');

      drawer.classList.add('is-opening');

      scrollLock.lock();



      window.requestAnimationFrame(function () {

        drawer.classList.add('is-open');

        drawer.classList.remove('is-opening');

      });



      const api = core();

      if (api) api.dispatch('onera:cart:open');

      refresh(null, { source: 'open' });

    };



    const overlay = drawer.querySelector('.onera-cart-drawer__overlay');

    if (overlay) {

      overlay.addEventListener('click', function () {

        close();

      });

    }



    if (closeBtn) {

      closeBtn.addEventListener('click', function () {

        close();

      });

    }



    drawer.addEventListener('click', function (event) {

      if (event.target.closest('[data-onera-cart-drawer-close]')) {

        close();

      }

    });



    document.addEventListener('keydown', function (event) {

      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {

        event.preventDefault();

        close();

        return;

      }

      if (event.key !== 'Tab' || !drawer.classList.contains('is-open')) return;

      const items = focusables();

      if (!items.length) return;

      const first = items[0];

      const last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {

        event.preventDefault();

        last.focus();

      } else if (!event.shiftKey && document.activeElement === last) {

        event.preventDefault();

        first.focus();

      }

    });



    if (panel) {

      panel.addEventListener('click', function (event) {

        event.stopPropagation();

      });

    }



    if (content) {

      content.addEventListener('click', function (event) {

        if (pending || refreshing) return;

        const upsellBtn = event.target.closest('[data-promo-upsell-add]');

        if (
          upsellBtn &&
          window.oneraCartPromotions &&
          typeof window.oneraCartPromotions.handleUpsellClick === 'function'
        ) {
          window.oneraCartPromotions.handleUpsellClick(event);
          return;
        }

        const line = event.target.closest('[data-onera-cart-line]');

        if (!line) return;

        const key = line.getAttribute('data-line-key');

        const qtyInput = line.querySelector('[data-onera-cart-qty]');

        if (!key || !qtyInput) return;



        if (event.target.closest('[data-onera-cart-qty-down]')) {

          event.preventDefault();

          changeLine(key, Math.max(0, parseInt(qtyInput.value, 10) - 1));

        } else if (event.target.closest('[data-onera-cart-qty-up]')) {

          event.preventDefault();

          changeLine(key, Math.max(1, parseInt(qtyInput.value, 10) + 1));

        } else if (event.target.closest('[data-onera-cart-remove]')) {

          event.preventDefault();

          removeLine(line, key);

        }

      });



      content.addEventListener('change', function (event) {

        if (pending || refreshing) return;

        const input = event.target.closest('[data-onera-cart-qty]');

        if (!input) return;

        const line = input.closest('[data-onera-cart-line]');

        if (!line) return;

        changeLine(

          line.getAttribute('data-line-key'),

          Math.max(0, parseInt(input.value, 10) || 0)

        );

      });

    }



    document.querySelectorAll('[data-onera-cart-open]').forEach(function (trigger) {

      trigger.addEventListener('click', function (event) {

        event.preventDefault();

        open();

      });

    });



    document.addEventListener('onera:cart:open', open);

    document.addEventListener('onera:cart:added', open);

    document.addEventListener('onera:promotions:evaluated', function (event) {
      if (!drawer.classList.contains('is-open')) return;
      var cart = event.detail && event.detail.cart;
      refresh(cart, { source: 'promotions' }).then(function () {
        if (closeBtn && drawer.classList.contains('is-open')) {
          window.setTimeout(function () {
            closeBtn.focus();
          }, OPEN_MS > 0 ? OPEN_MS : 0);
        }
      });
    });

    window.oneraOpenCartDrawer = open;

    window.oneraCloseCartDrawer = close;

    window.oneraRefreshCartDrawer = refresh;

  };



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', initCartDrawer);

  } else {

    initCartDrawer();

  }

})();


